/*
 * SmartHome-Energy — Vorbefüllung des Kontaktformulars für Sonderlängen
 * ---------------------------------------------------------------------------
 * Der Laufmeter-Konfigurator verlinkt bei Längen über der Maximallänge auf
 *   /pages/contact?anfrage=ueberlaenge&produkt=…&ausfuehrung=…&laenge=…&stueckzahl=…
 * Dieses Skript trägt daraus einen fertigen Anfragetext in das Nachrichtenfeld
 * ein, damit der Kunde nur noch Name und E-Mail ergänzen muss.
 *
 * Tut nichts ohne den Parameter `anfrage=ueberlaenge` und überschreibt niemals
 * bereits eingegebenen Text.
 */
(function () {
  'use strict';

  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    return;
  }
  if (params.get('anfrage') !== 'ueberlaenge') return;

  var produkt = params.get('produkt') || '';
  var ausfuehrung = params.get('ausfuehrung') || '';
  var laenge = params.get('laenge') || '';
  var stueckzahl = params.get('stueckzahl') || '';

  var lines = ['Anfrage: Sonderlänge über die im Shop bestellbare Maximallänge.', ''];
  if (produkt) lines.push('Produkt: ' + produkt);
  if (ausfuehrung) lines.push('Ausführung: ' + ausfuehrung);
  if (laenge) lines.push('Gewünschte Länge: ' + laenge);
  if (stueckzahl) lines.push('Stückzahl: ' + stueckzahl);
  lines.push('');
  lines.push('Bitte um Rückmeldung zu Machbarkeit, Preis und Lieferung. Danke!');
  var text = lines.join('\n');

  var tries = 0;

  function fill() {
    var ta =
      document.querySelector('textarea[name="contact[body]"]') ||
      document.querySelector('form[action*="/contact"] textarea');
    if (!ta) return false;
    if (ta.value && ta.value.trim() !== '') return true; // nichts überschreiben
    ta.value = text;
    ta.dispatchEvent(new Event('input', { bubbles: true }));

    var form = ta.closest('form');
    if (form && typeof form.scrollIntoView === 'function') {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return true;
  }

  function attempt() {
    if (fill()) return;
    if (++tries > 20) return;
    window.setTimeout(attempt, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }
})();
